import React, { useContext, useEffect, useMemo, useState, useRef } from "react";

import {
  Avatar,
  Box,
  Button,
  Card,
  Paper,
  CardActions,
  CardContent,
  CardHeader,
  Grid,
  InputLabel,
  Menu,
  MenuItem,
  TextField,
  Typography,
  List,
  ListItemButton,
  ListItemText,
  Chip,
  FormControl,
  Select,
  OutlinedInput,
  Autocomplete,
  Checkbox
} from "@mui/material";
import CircleIcon from '@mui/icons-material/Circle';
import TableStyle from "components/Content/Table/TableStyle.module.css";
import { Utils } from 'common/Utils';
import { PortalNames } from "common/Portals";
import { PrivateRoutesContext } from "app/PrivateRoutesContext";
import SortBox from "components/Filters/SortBox";
import _ from "lodash";
import { apiGet } from "app/Services/ApiService";
import { ap3ApiUrls, primeApiUrls } from "common/ApiUrls";
import {
  Chart as ChartJS, ArcElement, Tooltip, Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title
} from 'chart.js';
import {
  Doughnut, Bar,
  getElementAtEvent,
  getDatasetAtEvent
} from 'react-chartjs-2';
import TableAllData from "components/Content/CustomTable/TableAllData";

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { Margin } from "@mui/icons-material";
import { set } from "date-fns";

ChartJS.register(ArcElement, Tooltip, Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title);

export const barChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  minBarLength: 0,
  legend: {
    position: 'bottom',
  },
  scale: {
    pointStyle: {
      fontStyle: "bold",
    }
  }

};


const availableComplianceList = ['Provider Deposits', 'Carrier Disbursements', 'ACA Compliance', 'Cash in lieu', 'Contract Updates', 'Hours Management'];
const barChartlabels = ['Provider Deposits', 'Carrier Disbursements', 'ACA Compliance', 'Cash in lieu', 'Contract Updates'];
export const initBarChartData = {
  labels: barChartlabels,
  datasets: []
};
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
}
export default function Dashboard() {

  const failColor = "rgba(200, 0, 0, 0.85)"
  const failHoverColor = "rgba(200, 0, 0, 0.65)"
  const warningColor = "rgba(255,103,0, 0.85)"
  const warningHoverColor = "rgba(255,103,0, 0.65)"
  const passColor = "rgba(0, 128, 0, 0.85)"
  const passHoverColor = "rgba(0, 128, 0, 0.65)"
  const [isLoading, setIsLoading] = useState(false);
  const [showChart, setShowChart] = useState(true);
  const [contracts, setContracts] = useState([]);
  const [searchFilter, setSearchFilter] = useState("");
  const [filterSelected, setFilterSelected] = useState(null);
  const [searchContractor, setSearchContractor] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [complianceFilter, setComplianceFilter] = useState(barChartlabels);
  const [highLightedComplianceType, setHighLightedComplianceType] = useState('');
  const [companyFilter, setCompanyFilter] = useState({ label: 'ALL', id: 'ALL' });
  const [sortValue, setSortValue] = useState("name");
  const [colorFilter, setColorFilter] = useState("none");
  const [failedCompanies, setFailedCompanies] = useState([]);
  const [passCompanies, setPassCompanies] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [openRed, setOpenRed] = useState(true);
  const [openGreen, setOpenGreen] = useState(false);
  const [selectedCompanyList, setSelectedCompanyList] = useState([])
  const [anchorEl, setAnchorEl] = useState(null)
  const [beginDate, setBeginDate] = useState(dayjs().set('date', 1))
  const [endDate, setEndDate] = useState(dayjs().endOf('month'))
  const [barChartData, setBarChartData] = useState(initBarChartData);
  const { userInfo, setUserInfo, setCompany, setCurrentPortal } = useContext(PrivateRoutesContext);
  const [availableCompanyList, setAvailableCompanyList] = useState([]);
  const [availableCompanyIdList, setAvailableCompanyIdList] = useState([]);
  const [currentElement, setCurrentElement] = useState();
  const [openBeginDate, setOpenBeginDate] = useState(false);
  const [openEndDate, setOpenEndDate] = useState(false);
  const [beginDateError, setBeginDateError] = useState(null);
  const [endDateError, setEndDateError] = useState(null);
  const [chartPassFaildata, setChartPassFaildata] = useState({
    labels: ['Fail', 'Pass'],
    datasets: [
      {
        label: '# of contractors',
        data: [0, 0],
        backgroundColor: [
          'rgba(255, 99, 132, 0.2)',
          'rgba(60, 179, 113, 0.2)',
        ],
        borderColor: [
          'rgba(255, 99, 132, 1)',
          'rgba(60, 179, 113, 1)',
        ],
        borderWidth: 1,
      },
    ],
  });
  const openMenu = Boolean(anchorEl);
  const chartRef = useRef();


  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleFilterChange = (selectedFilter) => {
    console.log('handleFilterChange')
    console.log(selectedFilter)
    setFilterSelected(selectedFilter)
    setOpenGreen(true)
    setFailedCompanies(failedCompaniesList)
    // console.log('fail filter')

  };

  const colors = [
    { name: 'Red', value: 'rgba(200, 0, 0, 0.85)' },
    { name: 'Yellow', value: 'rgba(255,103,0, 0.85)' },
    { name: 'Green', value: 'rgba(0, 128, 0, 0.85)' }
  ]

  const getContractDashboard = (companyId, start, end) => {
    // setIsLoading(true);
    // console.log('getContracts')
    // console.log(primeApiUrls.getContractorDashboard(start, end))
    apiGet(primeApiUrls.getContractorDashboard(companyId, start, end))
      .then((response) => {
        console.log('dashboard contracts', response.data);
        setContracts(response.data);
        const uniqueCompanyId = [...new Set(response.data.map(r => r.companyId))];
        // if (uniqueCompanyId.length > 0) {
        //     setCompany(uniqueCompanyId[0])
        // }

        console.log('fail pass')
        const failedList = response.data.filter(({ status }) => status.value < 1);
        const passList = response.data.filter(({ status }) => status.value == 1);
        const graphData = complianceFilter.map(b => failedList.filter(f => f.compliances.filter(c => c.complianceType == b && (c.status == "failed" || c.status == "missing")).length > 0).length);
        setChartPassFaildata({
          labels: [`Fail: ${failedList.length}`, `Pass: ${passList.length}`],
          datasets: [
            {
              label: '# of contracts',
              data: [failedList.length, passList.length],
              backgroundColor: [
                'rgba(200, 0, 0, 1)',
                'rgba(0, 128, 0, 1)'
              ],
              hoverBackgroundColor: [
                'rgba(220, 0, 0, 1)',
                'rgba(0, 148, 0, 1)'
              ],
              borderWidth: 1,
            },
          ],
        })


        const totalContracts = failedList.length + passList.length;
        console.log('graphData')
        const graphColors = graphData.map(x => {
          if ((x / totalContracts) > 0.75) {
            return 'rgba(200, 0, 0, 1)'
          }
          else if ((x / totalContracts) > 0.5) {
            return 'rgba(255,103,0, 1)'
          }
          else {
            return 'rgba(0, 128, 0, 1)'
          }
        })
        const graphRed = graphData.map(x => {
          if ((x / totalContracts) > 0.75) {
            return x
          }
          return 0
        })
        console.log(graphRed, 'graph red')
        const graphYellow = graphData.map(x => {
          const per = (x / totalContracts);
          if (per <= 0.75) {
            return x
          }
          return 0
        })
        const graphGreen = graphData.map(x => {
          return totalContracts - x
        })
        console.log('before setBarChartData')
        setBarChartData({
          labels: complianceFilter,
          datasets: [{
            label: 'Failed over 75%',
            scales: {
              y: {
                display: false // Hide Y axis labels
              },
              x: {
                display: false // Hide X axis labels
              }
            },
            legend: {
              display: true
            },
            backgroundColor: failColor,
            hoverBackgroundColor: failHoverColor,
            data: graphRed,
            stack: 'Stack 0',
          }, {
            label: 'Failed less than 75%',
            legend: {
              display: true
            },
            backgroundColor: warningColor,
            hoverBackgroundColor: warningHoverColor,
            data: graphYellow,
            stack: 'Stack 0',
          }, {
            label: 'Pass',
            legend: {
              display: true
            },
            backgroundColor: passColor,
            hoverBackgroundColor: passHoverColor,
            data: graphGreen,
            stack: 'Stack 0',
          }]
        })

        let element = currentElement
        if (element.length > 0) {

          let foundColor = colors.find(c => c.value == barChartData.datasets[element[0].datasetIndex].backgroundColor)
          if (foundColor) {
            setColorFilter(foundColor)
          }
          let complianceType = complianceFilter[element[0].index]
          if (barChartData.datasets[element[0].datasetIndex].backgroundColor == failColor || barChartData.datasets[element[0].datasetIndex].backgroundColor == warningColor) {
            setSelectedCompanyList(response.data.filter(f => (f.compliances.filter(c => c.complianceType == complianceType && (c.status == "failed" || c.status == "missing")).length > 0)))
          }
          else {
            setSelectedCompanyList(response.data.filter(f => (f.compliances.filter(c => c.complianceType == complianceType && (c.status == "pass")).length > 0)
              && (f.compliances.filter(c => c.complianceType == complianceType && (c.status == "failed" || c.status == "missing")).length == 0)))
          }
        }
      })
      .catch(e => {
        //console.log(e);
        //setHasInitializationError(true);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }


  const statuses = useMemo(() => {
    var groups = [];

    if (companies && companies.length > 0) {
      groups = Utils.groupByArrays(companies, (c) => c.status.description)
        .map(g => g.key);
    }

    return groups;
  }, [companies])

  useEffect(() => {
    getAvailableCompanyList();
    getCompanies(beginDate?.format('YYYY-MM-DD'), endDate?.format('YYYY-MM-DD'));
  }, []);

  const failedCompaniesList = useMemo(() => {
    var regEx = new RegExp(Utils.escapeRegExp(searchContractor), 'i');
    return companies.filter(({ name, status }) => name.match(regEx) && status.value < 1)
  })

  const passCompaniesList = useMemo(() => {
    var regEx = new RegExp(Utils.escapeRegExp(searchContractor), 'i');
    return companies.filter(({ name, status }) => name.match(regEx) && status.value == 1)
  })

  const getAvailableCompanyList = () => {
    apiGet(ap3ApiUrls.getDashboard)
      .then((response) => {
        setAvailableCompanyList(response.data);
        setAvailableCompanyIdList(response.data.map(m => m.id))
      })
      .catch(e => {
        //console.log(e);
        //setHasInitializationError(true);
      })
      .finally(() => {
      });
  }

  const getCompanies = (start, end) => {
    console.log('getCompanies ')
    setIsLoading(true);
    apiGet(primeApiUrls.getDashboard(start, end))
      .then((response) => {
        // console.log('getCompanies dashboard companies', response.data);
        setCompanies(response.data);
        const failedList = response.data.filter(({ status }) => status.value < 1);
        setFailedCompanies(failedList)
        const passList = response.data.filter(({ status }) => status.value == 1);
        setPassCompanies(passList)
        const graphData = complianceFilter.map(b => failedList.filter(f => f.compliances.filter(c => c.complianceType == b && (c.status == "failed" || c.status == "missing")).length > 0).length);
        console.log('graphData 1', graphData);
        setChartPassFaildata({
          labels: [`Fail: ${failedList.length}`, `Pass: ${passList.length}`],
          datasets: [
            {
              label: '# of contractors',
              data: [failedList.length, passList.length],
              backgroundColor: [
                'rgba(200, 0, 0, 0.85)',
                'rgba(0, 128, 0, 0.85)'
              ],
              hoverBackgroundColor: [
                'rgba(220, 0, 0, 0.65)',
                'rgba(0, 128, 0, 0.65)'
              ],
              borderWidth: 1,
            },
          ],
        })

        const totalContractors = failedList.length + passList.length;
        console.log('graphData')
        const graphColors = graphData.map(x => {
          if ((x / totalContractors) > 0.75) {
            return 'rgba(200, 0, 0, 0.85)'
          }
          else if ((x / totalContractors) > 0.5) {
            return 'rgba(255,103,0, 0.85)'
          }
          else {
            return 'rgba(0, 128, 0, 0.85)'
          }
        })
        const graphRed = graphData.map(x => {
          if ((x / totalContractors) > 0.75) {
            return x
          }
          return 0
        })
        const graphYellow = graphData.map(x => {
          const per = (x / totalContractors);
          if (per <= 0.75) {
            return x
          }
          return 0
        })
        const graphGreen = graphData.map(x => {
          return totalContractors - x
        })
        console.log('before setBarChartData')
        setBarChartData({
          labels: complianceFilter,
          datasets: [{
            label: 'Failed over 75%',
            scales: {
              y: {
                display: false // Hide Y axis labels
              },
              x: {
                display: false // Hide X axis labels
              }
            },
            legend: {
              display: true
            },
            backgroundColor: failColor,
            hoverBorderWidth: 1,
            hoverBackgroundColor: failHoverColor,
            data: graphRed,
            stack: 'Stack 0',
          }, {
            label: 'Failed less than 75%',
            legend: {
              display: false
            },
            backgroundColor: warningColor,
            hoverBorderWidth: 1,
            hoverBackgroundColor: warningHoverColor,
            data: graphYellow,
            stack: 'Stack 0',
          }, {
            label: 'Pass',
            legend: {
              display: false
            },
            backgroundColor: passColor,
            hoverBorderWidth: 1,
            hoverBackgroundColor: passHoverColor,
            data: graphGreen,
            stack: 'Stack 0',
          }]
        })

        let element = currentElement
        if (element != null && element.length > 0) {

          let foundColor = colors.find(c => c.value == barChartData.datasets[element[0].datasetIndex].backgroundColor)
          if (foundColor) {
            setColorFilter(foundColor)
          }
          let complianceType = complianceFilter[element[0].index]
          if (barChartData.datasets[element[0].datasetIndex].backgroundColor == failColor || barChartData.datasets[element[0].datasetIndex].backgroundColor == warningColor) {
            console.log('fail list', complianceType)
            setSelectedCompanyList(response.data.filter(f => f.status.value < 1 && (f.compliances.filter(c => c.complianceType == complianceType && (c.status == "failed" || c.status == "missing")).length > 0)))
          }
          else {
            console.log('pass list', complianceType)
            setSelectedCompanyList(response.data.filter(f => f.status.value > 0 && (f.compliances.filter(c => c.complianceType == complianceType && (c.status == "pass")).length > 0)
              && (f.compliances.filter(c => c.complianceType == complianceType && (c.status == "failed" || c.status == "missing")).length == 0)))
          }
        }

      })
      .catch(e => {
        //console.log(e);
        //setHasInitializationError(true);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  const showContractor = (c) => {
    console.log(`show contractor`)
    console.dir(c)

    apiGet(primeApiUrls.getContractor(c.id))
      .then((response) => {
        console.log('dashboard companies', response.data);
        setCompanies(response.data);
        setShowChart(false);
      })
      .catch(e => {
        //console.log(e);
        //setHasInitializationError(true);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  const companyFilterUpdate = useMemo(() => {
    console.log('companyFilterUpdate')
    var comp = companies;
    if (companyFilter) {
      console.log('companyFilter', companyFilter)
      console.log('show contractor dashboard')
      if (companyFilter.id != 'ALL') {
        getContractDashboard(companyFilter.id, beginDate?.format('YYYY-MM-DD'), endDate?.format('YYYY-MM-DD'))
      }
    }
    else {
      console.log('no companyFilter', companyFilter)
      setCompanyFilter({ label: 'ALL', id: 'ALL' })
      console.log('back to main dashboard')
      getCompanies(beginDate?.format('YYYY-MM-DD'), endDate?.format('YYYY-MM-DD'));
    }
    setComplianceFilter(barChartlabels)
    setColorFilter("none")

    return comp;
  }, [companyFilter])

  const colorFilterUpdate = useMemo(() => {
    console.log('colorFilterUpdate')

    let status = ""
    if (colorFilter) {
      console.log('colorFilter', colorFilter)
    }
    if (colorFilter.name == "Green") {
      status = "pass"
    }
    else if (colorFilter.name == "Red") {
      status = "failed"
    }
    else if (colorFilter.name == "Yellow") {
      status = "failed"
    }

    if (status == "failed") {
      if (companyFilter && companyFilter.id != 'ALL') {
        //this sets at the contract level
        setSelectedCompanyList(contracts.filter(f => (f.compliances.filter(c => (c.complianceType == highLightedComplianceType || highLightedComplianceType == null || highLightedComplianceType == "")
          && (c.status == "failed" || c.status == "missing")).length > 0)))
      }
      else {
        //this sets at the company level
        setSelectedCompanyList(companies.filter(f => f.status.value < 1 && (f.compliances.filter(c => (c.complianceType == highLightedComplianceType || highLightedComplianceType == null || highLightedComplianceType == "")
          && (c.status == "failed" || c.status == "missing")).length > 0)))
      }
    }
    if (status == "pass") {
      if (companyFilter && companyFilter.id != 'ALL') {
        setSelectedCompanyList(contracts.filter(f => (f.compliances.filter(c => (c.complianceType == highLightedComplianceType || highLightedComplianceType == null || highLightedComplianceType == "")
          && (c.status == "pass")).length > 0)
          && (f.compliances.filter(c => (c.complianceType == highLightedComplianceType || highLightedComplianceType == null || highLightedComplianceType == "") && (c.status == "failed" || c.status == "missing")).length == 0)))
      }
      else {
        setSelectedCompanyList(companies.filter(f => f.status.value > 0 && (f.compliances.filter(c => (c.complianceType == highLightedComplianceType || highLightedComplianceType == null || highLightedComplianceType == "")
          && (c.status == "pass")).length > 0)
          && (f.compliances.filter(c => (c.complianceType == highLightedComplianceType || highLightedComplianceType == null || highLightedComplianceType == "")
            && (c.status == "failed" || c.status == "missing")).length == 0)))
      }
    }

    if (status == "") {
      if (companyFilter && companyFilter.id != 'ALL') {
        setSelectedCompanyList(contracts.filter(f => (f.compliances.filter(c => (c.complianceType == highLightedComplianceType || highLightedComplianceType == null || highLightedComplianceType == "")))))
      }
      else {
        setSelectedCompanyList(companies.filter(f => (f.compliances.filter(c => (c.complianceType == highLightedComplianceType || highLightedComplianceType == null || highLightedComplianceType == "")))))
      }
    }
    // let element = currentElement
    // console.log('element',element)
    // element[0].element.options.backgroundColor="black"
  }, [colorFilter])

  const complianceFilterUpdate = useMemo(() => {
    console.log('complianceFilterUpdate')
    var comp = companies;

    if (statusFilter) {
      console.log('statusFilter', statusFilter)
    }

    if (colorFilter) {
      console.log('colorFilter', colorFilter)
    }

    if (complianceFilter) {
      console.log('complianceFilter', complianceFilter)
    }

    var comp = companies;
    if (companyFilter) {
      console.log('companyFilter', companyFilter)
      console.log('show contractor dashboard')
      if (companyFilter.id != 'ALL') {
        getContractDashboard(companyFilter.id, beginDate?.format('YYYY-MM-DD'), endDate?.format('YYYY-MM-DD'))
      }
      else {
        getCompanies(beginDate?.format('YYYY-MM-DD'), endDate?.format('YYYY-MM-DD'))
      }
    }
    else {
      console.log('no companyFilter', companyFilter)
      setCompanyFilter({ label: 'ALL', id: 'ALL' })
      console.log('back to main dashboard')
      getCompanies(beginDate?.format('YYYY-MM-DD'), endDate?.format('YYYY-MM-DD'))
    }
    return comp;
  }, [complianceFilter])


  const highLightedComplianceTypeUpdate = useMemo(() => {
    console.log('highLightedComplianceType')
    if (highLightedComplianceType == '') {
      setColorFilter("none")
    }
  }, [highLightedComplianceType])

  const isNotFirstDay = (date) => {
    return date.date() != 1;
  }

  const isNotLastDay = (date) => {
    return date.date() != date.endOf('month').date();
  }

  const handleBeginDateChange = _.debounce((val) => {
    console.log(' handleBeginDateChange', val)
    setBeginDate(val)
    if (endDate > val) {
      setBeginDateError(null)
      setEndDateError(null)
      getCompanies(val?.format('YYYY-MM-DD'), endDate?.format('YYYY-MM-DD'))
    }
    else {
      setBeginDateError({ message: 'Begin date must be less than end date' })
      setEndDateError({ message: 'End date must be greater than begin date' })
    }
  }, 1000);

  const handleEndDateChange = _.debounce((val) => {
    console.log(' handleEndDateChange', val)
    setEndDate(val)
    if (beginDate < val) {
      setBeginDateError(null)
      setEndDateError(null)
      getCompanies(beginDate?.format('YYYY-MM-DD'), val?.format('YYYY-MM-DD'))
    }
    else {
      setBeginDateError({ message: 'Begin date must be less than end date' })
      setEndDateError({ message: 'End date must be greater than begin date' })
    }
  }, 1000);

  const goToEmployerPortal = (id) => {
    console.log(id)
    if (id) {
      setCompany(id);
      setCurrentPortal(PortalNames.Employer.Name);
      window.location.href = `/${PortalNames.Employer.Path}/dashboard`;
    }
  }
  const handleClickChart = (event) => {

    let element = getElementAtEvent(chartRef.current, event);
    setCurrentElement(element);
    if (element.length > 0) {
      console.log('element', element)

      let complianceType = complianceFilter[element[0].index]
      setHighLightedComplianceType(complianceType)
      //setComplianceFilter(complianceType)
      console.log(colors)
      console.log('color', barChartData.datasets[element[0].datasetIndex].backgroundColor)

      let foundColor = colors.find(c => c.value == barChartData.datasets[element[0].datasetIndex].backgroundColor)
      if (foundColor) {
        setColorFilter(foundColor)
      }
      if (barChartData.datasets[element[0].datasetIndex].backgroundColor == failColor || barChartData.datasets[element[0].datasetIndex].backgroundColor == warningColor) {
        console.log('fail list', complianceType)

        if (companyFilter && companyFilter.id != 'ALL') {
          //this sets at the contract level
          setSelectedCompanyList(contracts.filter(f => (f.compliances.filter(c => c.complianceType == complianceType && (c.status == "failed" || c.status == "missing")).length > 0)))
        }
        else {
          //this sets at the company level
          setSelectedCompanyList(companies.filter(f => f.status.value < 1 && (f.compliances.filter(c => c.complianceType == complianceType && (c.status == "failed" || c.status == "missing")).length > 0)))
        }
      }
      else {
        console.log('pass list', complianceType)
        if (companyFilter && companyFilter.id != 'ALL') {
          setSelectedCompanyList(contracts.filter(f => (f.compliances.filter(c => c.complianceType == complianceType && (c.status == "pass")).length > 0)
            && (f.compliances.filter(c => c.complianceType == complianceType && (c.status == "failed" || c.status == "missing")).length == 0)))
        }
        else {
          setSelectedCompanyList(companies.filter(f => f.status.value > 0 && (f.compliances.filter(c => c.complianceType == complianceType && (c.status == "pass")).length > 0)
            && (f.compliances.filter(c => c.complianceType == complianceType && (c.status == "failed" || c.status == "missing")).length == 0)))
        }
      }

    }
  }

  const subContractListColumnsArray = [
    {
      Header: "Subcontractor Name",
      accessor: (cell) => (
        <Box>
          {(availableCompanyIdList.includes(cell.id) ? <Button onClick={() => { goToEmployerPortal(cell.id) }} variant="outlined">{cell.name}</Button> : <>{cell.name}</>)}

        </Box>
      ),
    },
    {
      Header: "Compliance Status",
      accessor: "compliances",
      Cell: ({ row }) => (
        <Box>
          <ul>
            {/* {(row.original?.compliances?.map((c, idx) => <li key={`row-${row.id}-${idx}`}>{c.complianceType} {dayjs(c.beginDate).format('YYYY-MM-DD')} - {dayjs(c.endDate).format('YYYY-MM-DD')} {(c.status == 'missing' ? ' is missing' : `${c.status} ${c.notes}`)}</li>))} */}
            {(row.original?.compliances?.map((c, idx) => <li key={`row-${row.id}-${idx}`}>{c.complianceType} {(c.status == 'missing' ? ' is missing' : `${c.status} ${c.notes}`)} [{Utils.formatDate(c.beginDate)} - {Utils.formatDate(c.endDate)}]</li>))}
          </ul>
        </Box>
      )
    }
  ];

  const ColorFilterBox = ({ colors, colorFilter, setColorFilter }) => {
    return (
      <>

        <Grid container spacing={2}>
          <Grid item xs={3}>
            Filter By Color:
          </Grid>
          <Grid item xs={9}>
            <Button
              key={`filter-color-none`}
              className="me-1"
              variant={colorFilter.name === "none" ? "contained" : "outlined"}
              onClick={(e) => setColorFilter("none")}
              color="Grey"
            >
              None
            </Button>

            {colors.map((value) => {
              return (
                <Button
                  key={`filter-color-${value.name}`}
                  className="me-1"
                  variant={colorFilter.name === value.name ? "contained" : "outlined"}
                  onClick={(e) => setColorFilter(value)}
                  color={value.name}
                >
                  {value.name}
                </Button>
              )
            })
            }
          </Grid>
        </Grid>
      </>
    )
  }

  const CompanyFilterBox = ({ companies, companyFilter, setCompanyFilter }) => {
    return (
      <>
        <Autocomplete
          disablePortal
          id="company-filter"
          options={[{ label: 'ALL', id: 'ALL' }].concat(companies.map((value, index) => { return { label: value.name, id: value.id } }))}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          // sx={{ width: 300 }}
          value={companyFilter}
          autoHighlight
          getOptionLabel={(option) => option.label}
          onChange={(e, val) => setCompanyFilter(val)}
          // onInputChange={(event, newInputValue, reason) => {
          //   console.log('onInputChange')
          //   console.log(reason)
          //   if (reason === 'clear') {
          //     console.log('set to all ')
          //     setCompanyFilter({ label: 'ALL', id: 'ALL' })
          //     return
          //   } 
          //   // else if (reason != 'reset') {
          //   //   setCompanyFilter(newInputValue)
          //   // }
          // }}
          renderInput={(params) => <TextField {...params} label="Company Filter" />}
        />
      </>
    )
  }

  const SearchAndFilterBox = ({ companies, companyFilter, setCompanyFilter, colors, colorFilter, setColorFilter, compliances, complianceFilter, setComplianceFilter, highLightedComplianceType, setHighLightedComplianceType }) => {
    return (
      <Box
        component="form"
        noValidate
        autoComplete="off"
      >
        <Grid container spacing={2}>
          <Grid item md={6} sm={12} ><CompanyFilterBox companies={companies} companyFilter={companyFilter} setCompanyFilter={setCompanyFilter} /></Grid>
          {/* <Grid item xs={3}><SortBox sortValue={sortValue} setSortValue={setSortValue} /></Grid> */}
          <Grid item md={6} sm={12} ><ComplianceFilterBox compliances={compliances} complianceFilter={complianceFilter} setComplianceFilter={setComplianceFilter}
            highLightedComplianceType={highLightedComplianceType}
            setHighLightedComplianceType={setHighLightedComplianceType}
            colorFilter={colorFilter} /></Grid>
        </Grid>
        <Grid container spacing={2} mt={1}>
          <Grid item xs={12}><ColorFilterBox colors={colors} colorFilter={colorFilter} setColorFilter={setColorFilter} /></Grid>
          {/* <Grid item xs={3}><RegionFilterBox /></Grid> */}
        </Grid>
      </Box>
    );
  }
  return (
    <Box sx={{ marginTop: '20px' }}>
      <Grid container spacing={3}>
        <Grid item xs={1}>
        </Grid>
        <Grid item xs={9}>
          <Grid container spacing={4} >
            <p>&nbsp;</p>
          </Grid>
          <Grid container spacing={4} >
            <Grid item md={3} sm={12} >
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  open={openBeginDate}
                  onClose={() => setOpenBeginDate(false)}
                  id="beginDate"
                  name="beginDate"
                  minDate={dayjs('01/01/1900')}
                  value={beginDate}
                  onAccept={(newValue) => handleBeginDateChange(newValue)}
                  shouldDisableDate={isNotFirstDay}
                  label="Compliance Begin Date"
                  slotProps={{
                    textField: {
                      readOnly: true,
                      onClick: () => setOpenBeginDate(true),
                      error: !!beginDateError,
                      helperText: beginDateError?.message,
                    },
                    layout: {
                      sx: {
                        '.MuiPickersDay-root:not(.Mui-disabled):not(.Mui-selected)': {
                          color: '#000',
                          borderRadius: 2,
                          borderWidth: 1,
                          borderColor: '#2196f3',
                          border: '1px solid',
                          backgroundColor: '#bbdefb',
                        }
                      }
                    }
                  }}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item md={3} sm={12} >

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  open={openEndDate}
                  onClose={() => setOpenEndDate(false)}
                  id="endDate"
                  name="endDate"
                  minDate={beginDate}
                  value={endDate}
                  onChange={(newValue) => handleEndDateChange(newValue)}
                  shouldDisableDate={isNotLastDay}
                  label="Compliance End Date"
                  slotProps={{
                    textField: {
                      readOnly: true,
                      onClick: () => setOpenEndDate(true),
                      error: !!endDateError,
                      helperText: endDateError?.message,
                    },
                    layout: {
                      sx: {
                        '.MuiPickersDay-root:not(.Mui-disabled):not(.Mui-selected)': {
                          color: '#000',
                          borderRadius: 2,
                          borderWidth: 1,
                          borderColor: '#2196f3',
                          border: '1px solid',
                          backgroundColor: '#bbdefb',
                        }
                      }
                    }
                  }}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item md={6} sm={12} >

              <SearchAndFilterBox
                companies={companies}
                companyFilter={companyFilter}
                setCompanyFilter={setCompanyFilter}
                colors={colors}
                colorFilter={colorFilter}
                setColorFilter={setColorFilter}
                compliances={availableComplianceList}
                complianceFilter={complianceFilter}
                setComplianceFilter={setComplianceFilter}
                highLightedComplianceType={highLightedComplianceType}
                setHighLightedComplianceType={setHighLightedComplianceType}
              />
            </Grid>
          </Grid>
          <Grid container spacing={4} >
            <p>&nbsp;</p>
          </Grid>
          {showChart ?
            <Grid container spacing={4} sx={{ height: '360px' }}>
              <Grid item md={6} sm={12} sx={{ height: '380px' }}>
                <Paper sx={{ height: '350px' }}>
                  <Doughnut
                    options={{
                      padding: "0px",
                      maintainAspectRatio: false,
                      height: "400",
                      spacing: 2,
                      cutout: "70%",
                    }} data={chartPassFaildata} />
                </Paper>
              </Grid>
              <Grid item md={6} sm={12} sx={{ height: '380px' }}>
                <Paper sx={{ height: '350px' }}>
                  <Bar options={barChartOptions} data={barChartData} ref={chartRef} onClick={handleClickChart} />
                </Paper>
              </Grid>
            </Grid> : <></>}
          {selectedCompanyList.length > 0 ?
            <Grid container sx={{ marginTop: '50px' }}>
              <Grid item md={12} sm={12} >
                <TableAllData
                  className={TableStyle.TimeSheetsWrapper}
                  columns={subContractListColumnsArray}
                  data={selectedCompanyList}
                  headerContents={<span>Total Records: {selectedCompanyList.length} </span>}>
                </TableAllData></Grid></Grid> : <></>}
        </Grid>
      </Grid>
    </Box>
  );
}

function BasicSearch({ searchFilter, setSearchFilter }) {
  return (
    <>
      <InputLabel>&nbsp;</InputLabel> {/* hack alignment */}
      <TextField
        key="search"
        fullWidth
        variant="standard"
        label="Search"
        id="search"
        type="search"
        value={searchFilter}
        onChange={e => setSearchFilter(e.target.value)}
      />
    </>
  )
}

const StatusFilterBox = ({ statuses, statusFilter, setStatusFilter }) => {
  return (
    <TextField
      fullWidth
      variant="standard"
      select
      labelid="filter-status-label"
      id="filter-status"
      value={statusFilter}
      onChange={e => setStatusFilter(e.target.value)}
      label="Status Filter"
    >
      <MenuItem value="">
        <em>All</em>
      </MenuItem>
      {statuses.map((value, index) => <MenuItem key={`status-menu-${index}`} value={value}>{value}</MenuItem>)}
    </TextField>
  )
}
const translateColor = (colorFilter) => {
  if (colorFilter?.name) {
    switch (colorFilter?.name) {
      case "Green":
        return "success";
      case "Yellow":
        return "warning";
      case "Red":
        return "error";
      default:
        return "";
    }
  }
  return "";
}
const ComplianceFilterBox = ({ compliances, complianceFilter, setComplianceFilter, highLightedComplianceType, setHighLightedComplianceType, colorFilter }) => {
  return (
    <FormControl sx={{ maxWidth: 300 }}>
      <InputLabel id="compliance-multiple-checkbox-label">
        {highLightedComplianceType == '' ? <span>Compliance Filter</span> : <Chip label={highLightedComplianceType}
          color={translateColor(colorFilter)}
          onDelete={() => { setHighLightedComplianceType('') }}
        />}
      </InputLabel>
      <Select
        variant="standard"
        labelId="compliance-multiple-checkbox-label"
        id="compliance-multiple-checkbox"
        multiple
        value={complianceFilter}
        onChange={(event) => {
          const {
            target: { value },
          } = event;
          setComplianceFilter(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
          )
        }}
        input={<OutlinedInput label="Tag" />}
        renderValue={(complianceFilter) => complianceFilter.join(', ')}
        MenuProps={MenuProps}
      >
        {compliances.map((value, index) => <MenuItem key={`compliance-menu-${index}`} value={value}>
          <Checkbox checked={(complianceFilter.indexOf(value) > -1)} />
          <ListItemText primary={value} />
        </MenuItem>)}
      </Select>
    </FormControl>
  )
}

function CompanySummary(props) {
  const { setCompany, setCurrentPortal } = useContext(PrivateRoutesContext);
  let companyInfo = props.company;

  const handleClick = (e) => {
    if (companyInfo.id) {
      setCompany(companyInfo.id);
      setCurrentPortal(PortalNames.Employer.Name);
      window.location.href = `/${PortalNames.Employer.Path}/dashboard`;
    }
  }

  return (
    <Card
      sx={{
        maxWidth: 450,
        minHeight: "100%",
        border: 10,
        borderColor: companyInfo.status.color.htmlValue,
        padding: 1,
      }}>
      <CompanyHeader {...props} />
      <CardContent >
        <Typography gutterBottom variant="h5" component="div">
          Status: {companyInfo.status.description} <CircleIcon sx={{ color: companyInfo.status.color.htmlValue }} /> as of {Utils.today()}
        </Typography>
        {
          (companyInfo.notes ?
            companyInfo.notes.map((c, idx) => {
              return <Typography variant="body2" color="text.secondary" key={`ci-${idx}`}>
                {c}
              </Typography>
            }) : <></>)
        }
      </CardContent>
      <CardActions>
        {/* <Button onClick={handleClick} variant="outlined">View Employer Portal</Button> */}
      </CardActions>
    </Card>
  );
}

function CompanyHeader(props) {
  const [avatar, setAvatar] = useState("");

  useEffect(() => {
    let companyInfo = props.company;
    let a = null;
    if (companyInfo.image && companyInfo.image.data !== null) {
      a = <img alt={companyInfo.name}
        src={`data:${companyInfo.image.mime};base64, ${companyInfo.image.data}`}
        style={{ height: "140px", maxWidth: "100%" }}
      />
    }
    else if (companyInfo.image && companyInfo.image.uri !== "") {
      a = <Avatar
        sx={{ width: 100, height: 100 }}
        {...stringAvatar(companyInfo.name)}
        alt={companyInfo.name}
        src={companyInfo.image.uri}
      />
    } else {
      a = <Avatar {...stringAvatar(companyInfo.name)} />
    }

    setAvatar(a);
  }, [props])

  const stringToAvatarColor = (string, s = 30, l = 50) => {
    let hash = 0;
    let i;
    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    var h = hash % 360;
    return `hsl(${h}), ${s}%, ${l}%`;
    /* eslint-enable no-bitwise */
  }

  const stringAvatar = (name) => {
    let nameUpperCase = name.toUpperCase();
    let n = nameUpperCase.trim().split(' ').filter(String); //remove empty spaces, caused when multiple spaces used
    let a = nameUpperCase.slice(0, 2)
    // console.log(n,"before if");
    if (n.length > 1) {
      a = `${n[0][0]}${n[1][0]}`
    }

    var bgcolor = stringToAvatarColor(name.trim());

    return {
      sx: {
        width: 100,
        height: 100,
        bgcolor: bgcolor,
      },
      children: `${a}`,
    };
  }

  return (
    <Box sx={{ height: 200, textAlign: "center" }}>
      <CardHeader
        title={props.company.name}
        titleTypographyProps={{ variant: "h4", textAlign: "center" }}
        avatar={avatar}
      />
    </Box>
  )
}
